<div class="reminders__header">
  @if (!ppHide) {
    <pp-button (ppAction)="back()" ppStyle="text">
      <pp-icon
        [ppSrc]="EIconPath.ARROW_LEFT"
        ppColor="primary-950"
        [ppDisplayContents]="true"
      ></pp-icon>
      {{ 'back_to_point' | ppTranslate }}
    </pp-button>
  }
  <span class="reminders__headerText">{{ 'reminders_on_point' | ppTranslate }}</span>
  <pp-button data-test="setNewReminderButton" (ppAction)="newReminder()" ppStyle="primary">
    + {{ 'set_reminder' | ppTranslate }}
  </pp-button>
</div>
